/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable import/first */
// Entry point for the feed.web.js bundle, this is the first JS from our app that runs
if (window.bugsnag && window.bugsnagClientOptions) {
    var feedBugsnagOptions = {
        ...window.bugsnagClientOptions,
        apiKey: 'd3e49249a160a794692b2c579b6b0700',
        appVersion: process.env.FEED_VERSION || null,
    };

    window.bugsnagClient = window.bugsnag(feedBugsnagOptions);
}

// These are the minimum polyfills so that legacy browsers can
// dynamically import
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.array.includes';

// Always polyfill generators because we can't reliably detect
// generator support in browser
import 'regenerator-runtime/runtime';

// polyfill requestAnimationFrame for old browsers
import 'raf/polyfill';

import featureDetect from 'feature-detect-es6';

import './index.scss';
import './EdsOverrides.scss';

// Sometimes dynamic imports fail on slow connections
// For now just silence the errors to stop sending to Bugsnag (there are too many)
// eslint-disable-next-line func-style
function genericDynamicImportErrorHandler(err) {
    if (process.env.NODE_ENV !== 'production') {
        throw err;
    }
    return null;
}

// These CSS imports we still want, but do a dynamic import here so they are
// not included in the first bundle, they get loaded asyncronously

import('eventbrite_design_system/css/eds.css').catch(
    genericDynamicImportErrorHandler,
);

if (featureDetect.all('class', 'spread', 'let', 'arrowFunction')) {
    import('./index.post').catch(genericDynamicImportErrorHandler);
} else {
    // Only load core-js polyfill if needed, it's big
    // Todo: split this out to exclude the ones we already imported
    import('core-js/stable')
        .then(() =>
            import('./index.post').catch(genericDynamicImportErrorHandler),
        )
        .catch(genericDynamicImportErrorHandler);
}
